<template>
    <div>
        <b-loading :can-cancel="true" :is-full-page="true" :active.sync="loading"></b-loading>
        
        <div class="columns is-multiline">
            <div class="column is-full">
                <b-field label="Info de pagos en cuotas en detalle de producto." message="Mostrar que tarjetas se pueden usar para pagar en cuotas en el detalle de un producto.">
                    <b-switch v-model="info.mpInsProd">
                        
                    </b-switch>
                </b-field>
            </div>
            <div class="column is-full">
                <b-field label="Mostrar codigo en detalle de producto">
                    <b-switch v-model="info.displaySku">
                        
                    </b-switch>
                </b-field>
            </div>
            <div class="column is-full">
                <b-field label="Desgloce en dolares" message="Esto va a mostrar los desgloces en pesos y dolares si esta activado, si no solo lo muestra en pesos.">
                    <b-switch v-model="info.usdReports">
                        
                    </b-switch>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Color primario">
                    <div class="control has-icons-left is-clearfix">
                        <input maxlength="7" autocomplete="off" class="input" v-model="info.primaryColor">
                        <span class="icon is-left">
                            <i class="fas fa-square fa-lg" :style="{ color: info.primaryColor }"></i>
                        </span>
                    </div>
                </b-field>
                <p class="is-size-7">Si usas un codigo, agregar # al principio</p>
            </div>
            
            <div class="column is-one-third">
                <b-field label="Color secundario">
                    <div class="control has-icons-left is-clearfix">
                        <input maxlength="7" autocomplete="off" class="input" v-model="info.secondaryColor">
                        <span class="icon is-left">
                            <i class="fas fa-square fa-lg" :style="{ color: info.secondaryColor }"></i>
                        </span>
                    </div>
                </b-field>
                <p class="is-size-7">Si usas un codigo, agregar # al principio</p>
            </div>
        
            <div class="column is-one-third">
                <b-field label="Texto negro sobre color primario?">
                    <b-switch
                    v-model="info.blackText">
                    </b-switch>
                </b-field>
                <p class="is-size-7">Si esta activado el texto de los botones sera negro, si no blanco.</p>
            </div>

        </div>

        <div class="columns">
            <div class="column is-half has-text-center">
                <b-field label="Logo de la empresa">
                    <b-upload 
                        v-model="dropLogo"
                        drag-drop
                        @input="encodeLogo"
                        >
                        <section class="section" >
                            <div class=" has-text-centered">
                                <p>
                                    <b-icon
                                        icon="upload"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <p>Arrastra el archivo hasta aca, o haz click</p>
                            </div>
                        </section>
                    </b-upload>
                </b-field>
            </div>
            <div class="column is-half has-text-centered">
                <p v-if="info.logo || encodedLogo" class="is-size-5">Logo display</p>
                <img v-if="info.logo && !encodedLogo" class="displayImgs" :src="info.logo" >
                <img v-if="encodedLogo" class="displayImgs" :src="logoDisplay" >
            </div>
        </div>

        <div class="columns">
            <div class="column is-half">
                <b-field label="Favicon">
                    <b-upload 
                        v-model="dropFavicon"
                        drag-drop
                        @input="encodeFavicon"
                        >
                        <section class="section" >
                            <div class=" has-text-centered">
                                <p>
                                    <b-icon
                                        icon="upload"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <p>Arrastra el archivo hasta aca, o haz click</p>
                            </div>
                        </section>
                    </b-upload>
                </b-field>
            </div>
            <div class="column is-half has-text-centered">
                <p v-if="info.favicon || encodedFavicon" class="is-size-5">Favicon display</p>
                <img v-if="info.favicon && !encodedFavicon" class="displayImgs" :src="info.favicon" >
                <img v-if="encodedFavicon" class="displayImgs" :src="faviconDisplay" >
            </div>
        </div>

        <div class="columns is-multiline">
            <div class="column is-full">
                <b-field label="Sobre nosotros">
                    <b-input
                    type="textarea"
                    v-model="info.aboutUs">
                    </b-input>
                </b-field>
            </div>

            <div class="column is-full">
                <p class="has-text-weight-bold is-size-4">Campos meta</p>
                <p>Controla los parametros que la mayoria de buscadores usan para rankear mejor tu sitio en las busquedas</p>
            </div>

            <div class="column is-full">
                <b-field label="Descripcion" 
                message="Describe tu empresa">
                    <b-input
                    type="textarea"
                    v-model="info.metaDescription"
                    maxlength="300">
                    </b-input>
                </b-field>
            </div>

            <div class="column is-full" >
                <b-field label="Palabras clave"
                message="Palabras relevantes a tu rubro, escribelas separadas con coma!">
                    <b-input
                    type="textarea"
                    v-model="info.metaKeywords"
                    maxlength="200">
                    </b-input>
                </b-field>
            </div>

            <div class="column is-full">
                <b-field label="Scripts de tracking de analiticas.">
                    <b-input
                    type="textarea"
                    v-model="info.analyticsScrips">
                    </b-input>
                </b-field>
            </div>

            <div class="column m-t-30 is-full has-text-centered">
                <b-button
                type="is-primary"
                :loading="saveLoad"
                rounded
                @click="saveDetails">
                    <b-icon icon="save" size="is-small"></b-icon>
                    Guardar la informacion.
                </b-button>
            </div>
        </div>

    </div>
</template>


<script>
import { getHandler, patchHandler } from '../../../services/http';

export default {
    name:"BasicInfo",
    props:{
        details:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            loading:false,
            info:{},
            dropLogo:"",
            encodedLogo:"",
            dropFavicon:"",
            encodedFavicon:"",
            saveLoad:false
        }
    },
    methods:{
        encodeLogo(){
            let reader = new FileReader();
            reader.readAsDataURL(this.dropLogo);
            reader.onloadend = (event) => {
                this.info.logo = reader.result
                this.encodedLogo = reader.result
            }
        },
        encodeFavicon(){
            let reader = new FileReader();
            reader.readAsDataURL(this.dropFavicon)
            reader.onloadend = (event) =>{
                this.info.favicon = reader.result
                this.encodedFavicon = reader.result
            }
        },
        async fetchDetails(){
            this.loading = true
            let resp = await getHandler(this.details, {error:false, success:false})
            this.info = resp
            console.log(resp)
            this.loading = false
        },

        async saveDetails(){
            this.saveLoad = true
            let msg = {
                resource:"notify"
            }
            let resp = await patchHandler(this.details, this.info, {error:msg, success:msg})
            this.saveLoad = false
            this.fetchDetails()
        }
    },
    computed:{
        logoDisplay(){
            if(this.dropLogo){
                return window.URL.createObjectURL(this.dropLogo);
            }
        },
        faviconDisplay(){
            if(this.dropFavicon){
                return window.URL.createObjectURL(this.dropFavicon);
            }
        },
    },
    created(){
        this.fetchDetails()
    }
    
}
</script>

<style lang="scss" scoped>
@import "./../../../scss/main.scss";

.displayImgs{  
    max-height: 250px;
    border:1px solid #ddd;
    border-radius: 5px;
}
</style>
